import React from 'react';
import './index.scss';

function Main() {
  return (

    <div className="video-container">
    <iframe title="builds-reel" src="https://player.vimeo.com/video/1168036440" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen/>

    <iframe title="builds-reel" src="https://player.vimeo.com/video/820730298?h=1ed8ab157d" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen/>

    </div>


  );
}

export default Main;

